import { createFileRoute } from '@tanstack/react-router';
import AdminPlayers from '../../pages/admin/Players';
import { playersQueryOptions } from '../../lib/queryOptions';

export const Route = createFileRoute('/admin/players')({
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureQueryData(playersQueryOptions()),
  component: AdminPlayers,
});
